import { render, staticRenderFns } from "./FolderTaskBand.vue?vue&type=template&id=0f87b8f0&scoped=true"
import script from "./FolderTaskBand.vue?vue&type=script&lang=js"
export * from "./FolderTaskBand.vue?vue&type=script&lang=js"
import style0 from "./FolderTaskBand.vue?vue&type=style&index=0&id=0f87b8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f87b8f0",
  null
  
)

export default component.exports